import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'


export default {
    props: {
        index: Number,
        modelId: Object,
        modelObject: Object,
        actionLabel: String,
        actionTitle: String,
        editMode: Boolean,
        parentScreenParameters: Object
    },

    mixins: [],

    components: {
        
    },

    data: function () {
        return {
            screenKey: "GlobalConfigurationAddEditModel",
            loading: false,
            actionLocked: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {
                
            },
            
            applicationResources: null,
            toolTipStates: {},
            dataSourceLookupGlobalConfigurationNames: [],

        }
    },

    computed: {
        screenTitle: function () {
            return 'Global Configuration';
        },

        
    },

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }
            
            return this.modelErrors[field];
        },

        

        emptyModel() {
            return {
                Id: 0,
                Name: null,
                Value: null,

            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                if (((typeof this.modelId === 'number') && this.modelId > 0) ||
                    ((typeof this.modelId === 'string') && this.modelId !== '')) {
                    if(true){
                    let url = this.$prepareServerUrl('/api/ui/global_configuration/{id}', this.modelId, this.modelObject, this.$route.params);
                    let response = await this.$http.get(url, {  });
                    if (this.$processServerJsonResponse(response.body) == false) {
                        this.model = response.body;
                        
                        
                    }
                } 
                else {
                    this.model = this.emptyModel();
                    this.$applyModelFields(this.modelObject, this.model);
                }
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onSaveModelDataSource() {
            try {
                this.loading = true;
                this.modelErrors = null;

                let url = this.$prepareServerUrl('/api/ui/global_configuration/{id?}', this.modelId, this.modelObject, this.$route.params);
                let response = await this.$http.post(url, this.model, {  });

                this.$processServerJsonResponse(response.body, this.refreshScreen);

                this.model = response.body;
                return true;
            }
            catch (ex) {
                if (ex.body.errors) {
                    this.modelErrors = ex.body.errors;
                   return false;
                } else {
                    this.$processException(ex);    
                }

                return false;
            }
            finally {
                this.loading = false;
            }
        },

        async onLookupGlobalConfigurationNamesLookupDataSource(parentValue) {
            
            let url = '/api/ui/global_configuration/lookup';
            url = this.$prepareServerUrl(url, this.modelId, this.modelObject ?? this.model);
            let response = await this.$http.get(url);
            this.dataSourceLookupGlobalConfigurationNames = response.body;
        },

        onNameChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupGlobalConfigurationNames).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        
        onLoadFieldDataSources() {
            this.onLookupGlobalConfigurationNamesLookupDataSource();

        },

        async show() {
            await this.onLoadModelDataSource();
                this.onLoadFieldDataSources();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        async onDialogHide() {
            this.$emit('hide');
            
        },

        async onOkClick() {
            if(this.actionLocked)
                return;
            try {
                this.actionLocked = true;
                let validateResult = await this.$refs.modelForm.validate();
                if (validateResult) {
                    let saveResult = await this.onSaveModelDataSource();
                if (saveResult) {
                    this.$emit('ok', { index: this.index, model: this.model, files: null });
                    this.hide();
                }
                }
            }
            finally {
                this.actionLocked = false;
            }
        },

        onCancelClick() {
            this.hide();
        }
    }
}